import React, { memo, useRef } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

function useDomElement(elementId) {
  const domRef = useRef(document.getElementById(elementId));

  return domRef.current;
}

function Portal({ elementId, Component, ...props }) {
  const domEl = useDomElement(elementId);
  return domEl ? createPortal(<Component {...props} />, domEl) : null;
}

Portal.propTypes = {
  elementId: PropTypes.string.isRequired,
  Component: PropTypes.func.isRequired,
};

export default memo(Portal);
